import { PropsWithChildren, memo } from "react";
import { FormProvider as Provider, UseFormReturn } from "react-hook-form";

import { FormMetadataContextProvider } from "../../context";
import { FormMetadata } from "../../types";

export type FormProviderProps<Metadata extends FormMetadata> = UseFormReturn<any> &
  PropsWithChildren<{ metadata: Metadata }>;

function FormProvider<Metadata extends FormMetadata>(props: FormProviderProps<Metadata>) {
  const { metadata, children, ...rest } = props;

  return (
    <FormMetadataContextProvider<Metadata> metadata={metadata}>
      <Provider {...rest}>{children}</Provider>
    </FormMetadataContextProvider>
  );
}

const Wrapper = memo(FormProvider) as typeof FormProvider;

export { Wrapper as FormProvider };
